var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSofaLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.9,89.4c0.7,0,1.4-0.3,1.9-0.8l4.4-4.4c1-1,1-2.7,0-3.7c-0.5-0.5-1.2-0.8-1.9-0.8s-1.4,0.3-1.9,0.8 l-4.4,4.4c-0.5,0.5-0.8,1.2-0.8,1.9s0.3,1.4,0.8,1.9C101.5,89.2,102.1,89.4,102.9,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,100.5c0.7,0,1.4-0.3,1.9-0.8l4.4-4.4c1-1,1-2.7,0-3.7c-0.5-0.5-1.2-0.8-1.9-0.8c-0.7,0-1.4,0.3-1.9,0.8 L89.9,96c-0.5,0.5-0.8,1.2-0.8,1.9s0.3,1.4,0.8,1.9S91.1,100.5,91.8,100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.7,91.6c-0.5-0.5-1.2-0.8-1.9-0.8s-1.4,0.3-1.9,0.8c-1,1-1,2.7,0,3.7l4.4,4.4c0.5,0.5,1.2,0.8,1.9,0.8 c0.7,0,1.4-0.3,1.9-0.8c1-1,1-2.7,0-3.7L104.7,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.3,88.7c0.5,0.5,1.2,0.8,1.9,0.8s1.4-0.3,1.9-0.8s0.8-1.2,0.8-1.9s-0.3-1.4-0.8-1.9l-4.4-4.4 c-0.5-0.5-1.2-0.8-1.9-0.8s-1.4,0.3-1.9,0.8c-1,1-1,2.7,0,3.7L94.3,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.5,88.9c-2-24.2-21.2-38.9-40.3-43c-3.4-8.2-12.4-13.5-17.8-16.6l-1-0.6c-5.8-3.4-14.7-5.4-24.4-5.4 c-9.9,0-19,2-24.9,5.5l-1,0.6c-5.5,3.2-14.7,8.6-18,17.1C45,49.3,35.7,54.7,29,61.6c-7.4,7.6-11.6,16.8-12.5,27.3 c-9.6,1.1-17,9.3-17,19.1c0,8.8,5.9,16.4,14.4,18.6l16.3,39.3c0.7,1.6,2.2,2.6,3.9,2.6h11.4v7c0,0.9,0.7,1.6,1.6,1.6h12.5 c0.9,0,1.6-0.7,1.6-1.6v-7h76.5v7c0,0.9,0.7,1.6,1.6,1.6h12.5c0.9,0,1.6-0.7,1.6-1.6v-7h11.4c1.7,0,3.3-1,3.9-2.6l16.3-39.3 c8.5-2.2,14.4-9.8,14.4-18.6C199.5,98.2,192.1,90,182.5,88.9z M178.1,121.2L162,160H37l-16-38.7c-0.6-1.4-1.9-2.4-3.4-2.6 C12.1,118,8,113.4,8,108c0-5.9,4.8-10.8,10.8-10.8c3.2,0,6.3,1.5,8.3,4.1c0.2,0.2,0.4,0.5,0.7,0.7l19.1,28.2 c0.8,1.2,2.1,1.9,3.5,1.9c0.3,0,0.5,0,0.8-0.1c16.3-3.1,31.7-4.6,47-4.6s31.5,1.5,49.5,4.6c0.2,0,0.5,0.1,0.7,0.1 c1.4,0,2.7-0.7,3.5-1.9l19.1-28.1c0.3-0.2,0.5-0.5,0.8-0.7c2.1-2.6,5.1-4.1,8.3-4.1c5.9,0,10.8,4.8,10.8,10.8 c0,5.4-4.1,10-9.5,10.6C180,118.8,178.7,119.8,178.1,121.2z M62.7,51c1.5-6.4,9.5-11.1,14.8-14.3l1-0.6c4.6-2.7,12.2-4.3,20.5-4.3 c8.1,0,15.6,1.6,20.1,4.2l1,0.6c5.2,3.1,13.2,7.7,14.6,14c0.4,1.7,1.8,3,3.5,3.2c16.5,2.6,34.1,15,35.8,36c-3,1-5.8,2.8-8,5.2 c-0.5,0.3-1,0.7-1.3,1.2L146.5,123c-17.6-2.9-33.4-4.3-48.3-4.3s-29.8,1.4-45.8,4.2L34.3,96.3c-0.3-0.4-0.7-0.8-1.2-1.1 c-2.2-2.5-5-4.3-8.1-5.4c1.7-20.7,19.3-32,34.5-35.6C61.1,53.9,62.3,52.6,62.7,51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofaLight);
export default __webpack_public_path__ + "static/media/sofa_light.7b1f87656b6d5c2a8af223ab8bb4ab6a.svg";
export { ForwardRef as ReactComponent };